import { GradientText } from '@/components/GradientText';
import { t } from 'i18next';

export const CardNotFound = () => (
  <div className="flex h-screen w-full items-center justify-center bg-gradient-to-br from-sky-50 to-white">
    <div className="rounded-xl bg-white p-8 shadow-lg">
      <GradientText className="mb-4 text-center text-xl font-bold">
        {t('digitalCard:notFound')}
      </GradientText>
    </div>
  </div>
);
